import React from 'react';
import styled, { css } from 'styled-components';
import {
  brandColours,
  fontSize,
  fontWeights,
  minBreakpointQuery,
  standardColours,
  standardTransition,
} from '../../styles';
import { Link } from './Link';

const commonButtonStyles = () => {
  return css`
    display: inline-block;
    padding: 18px 36px;
    font-weight: ${fontWeights.bold};
    text-align: center;
    background-color: ${brandColours.tertiary};
    border-radius: 32px;
    transition: ${standardTransition('color')},
      ${standardTransition('background-color')};

    ${({ isCreative }) => {
      if (isCreative) {
        return css`
          color: ${standardColours.white};
        `;
      }
    }}

    ${minBreakpointQuery.small`
      ${fontSize(17)};
    `}

    ${minBreakpointQuery.large`
      ${fontSize(18)};
    `}

    &:hover {
      color: ${standardColours.white};
      background-color: ${brandColours.secondary};
    }
  `;
};

const StyledButton = styled.button`
  ${commonButtonStyles()};
  border: none;
`;

const StyledButtonLink = styled(Link)`
  ${commonButtonStyles()};
`;

export const Button = ({ children, ...props }) => {
  const ButtonComponent = props.to ? StyledButtonLink : StyledButton;

  return (
    <ButtonComponent
      isCreative={process.env.GATSBY_SITE_THEME === 'creative'}
      {...props}
    >
      {children}
    </ButtonComponent>
  );
};
